module.exports = __webpack_public_path__ + "img/image-order-status-15-block.160e1f29.png";